import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import { Box, Button, FormGroup, CircularProgress, FormHelperText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import beableAdminService from '../../../services/BeableAdminService';
import { BeableAdminDTO } from '@beable/roster-backend-client-v1';
import { getStyles } from '../styles';

function getModalStyle() {
    return {
        top: `37.5vh`,
        left: `37.5vw`,
        width: '25vw',
        minHeight: '25vh',
    };
}

const emptyUserProfile: BeableAdminDTO = {
    username: "",
    id: "",
    firstName: "",
    lastName: ""
}

interface DeleteBeableAdminModalProps {
    open: boolean;
    handleClose: (deleted?: boolean) => void;
    profile: BeableAdminDTO;
}

export default function DeleteBeableAdminModal(props: DeleteBeableAdminModalProps) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [modalStyle] = useState(getModalStyle);
    const [profile, setProfile] = useState<BeableAdminDTO>(emptyUserProfile);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);

    const submitForm = async () => {
        setLoading(true);
        const success = await beableAdminService.deleteBeableAdmin(profile.id);
        setLoading(false);
        if (success) props.handleClose(true);
        else setError(true);
    };

    return (
        <Modal
            aria-labelledby="admin-modal-title"
            aria-describedby="admin-modal-description"
            // open={ props.open ? props.open : false }
            open={ props.open }
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={{ ...modalStyle, ...styles.paper }}>
                <h2 id="admin-modal-title">You are about to permanently remove {profile && profile.username ? profile.username : " "}!</h2>
                <p id="admin-modal-description">This action cannot be undone.</p>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button variant="contained" sx={styles.btnDanger} disabled={error} onClick={submitForm}>Delete</Button>
                    <Button
                        variant="contained"
                        onClick={() => props.handleClose(false)}
                        sx={styles.ml2}>Close</Button>
                </FormGroup>
                {isLoading ? <CircularProgress color="primary" /> : undefined}
                {error && <FormHelperText sx={styles.redTxt}>User not found</FormHelperText>}
            </Box>
        </Modal>
    );
}